import type { ProspectListRead } from '@signalvote/shared';
import { PendingButton } from '@/components/ui/pending-button';
import { useRetryProspectList } from '@/hooks/queries';
import { failedPartway } from '@/lib/fundraising/prospectListUpload';

/**
 * Carry on an upload that broke partway, from the row it reached. Nothing already saved is written
 * again, so no one is duplicated — unlike uploading the same file as a new list.
 */
export function ProspectListRetry({ list }: { list: ProspectListRead }) {
  const { mutate: retryList, isPending, error } = useRetryProspectList();

  if (!failedPartway(list)) return null;

  return (
    <div className="flex flex-col items-end gap-1">
      <PendingButton
        variant="outline"
        size="sm"
        pending={isPending}
        onClick={() => retryList({ id: list.id, concurrencyToken: list.concurrencyToken })}
      >
        Retry
      </PendingButton>
      {error && <p className="text-xs text-amber-700">{error.message}</p>}
    </div>
  );
}
